var map = {
	"./account_fill.png": "C6nL",
	"./all_workbench_fill.png": "m2mS",
	"./amazon_fill.png": "Fynm",
	"./analytics_fill.png": "15dV",
	"./bi_fill.png": "Kvej",
	"./bill_fill.png": "Qz+3",
	"./charge_fill.png": "GC1w",
	"./cloud_fill.png": "FgiY",
	"./company_fill.png": "1ZL8",
	"./customer_fill.png": "BDPe",
	"./data_analysis_fill.png": "XhC4",
	"./finance_fill.png": "IgQE",
	"./home_fill.png": "tSq+",
	"./kehugzt_fill.png": "UdNa",
	"./msg_fill.png": "YdvJ",
	"./platform_fill.png": "X74+",
	"./reserved_instance_fill.png": "+g3W",
	"./savings_plan_fill.png": "30s2",
	"./set_fill.png": "HOwm",
	"./table_fill.png": "xghU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uEif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu ^\.\/.*_fill\.png$
// module id = uEif
// module chunks = 10